module.exports = __webpack_public_path__ + "img/sisley-logo_white-bigger.d9d3751a.svg";